import { buildMediaUrl } from '../config/api';
import defaultMale from '../assets/default-male.png';
import defaultFemale from '../assets/default-female.png';

/**
 * Returns the profile photo URL for a user/profile.
 * If the user has a photo, it returns the processed URL.
 * If not, it returns a default placeholder based on gender.
 * 
 * @param {Object} profile - User or profile object containing profilePhoto and gender
 * @returns {string} - The URL to display
 */
export const getProfilePhotoUrl = (profile) => {
    if (!profile) {
        // Return neutral placeholder if no profile object
        return 'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y';
    }

    // If photo exists, return it
    if (profile.profilePhoto) {
        if (profile.profilePhoto.startsWith('http')) {
            return profile.profilePhoto;
        }
        return buildMediaUrl(profile.profilePhoto);
    }

    // No photo, check gender
    const gender = (profile.gender || '').toLowerCase();

    if (gender === 'male') {
        return defaultMale;
    } else if (gender === 'female') {
        return defaultFemale;
    }

    // Default neutral
    return 'https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y';
};
